import { Component } from "@angular/core";
import { MakeProvider } from "../abstract-custom-control";
import { FormGroup, FormControl } from "@angular/forms";
import { BaseDataService } from "../../base-services/base-data.service";
import { ActivatedRoute } from "@angular/router";

@Component({
    selector: 'yt-reset-password',
    templateUrl: './reset-password.component.html',
    providers: [ MakeProvider(ResetPasswordComponent)]
})
export class ResetPasswordComponent {
    constructor(private baseDataService: BaseDataService,
                private activatedRoute: ActivatedRoute){

    }

    response: boolean;

    resetPasswordFormGroup: FormGroup = new FormGroup({
        Password: new FormControl(),
        ConfirmPassword: new FormControl(),
        Code: new FormControl(),
        Id: new FormControl()
    })

    submitted: boolean = false;
    resetingPassword: boolean = false;

    ngOnInit() {
        this.activatedRoute.queryParams
            .subscribe(params => {
                this.resetPasswordFormGroup.get('Code').setValue(params.code);
                this.resetPasswordFormGroup.get('Id').setValue(params.param);
            })
    }

    ResetPassword() {
        if(this.resetPasswordFormGroup.valid){
            this.resetingPassword = true;
            this.baseDataService.GetData('account', 'resetPassword', this.resetPasswordFormGroup.getRawValue())
                .subscribe(response => {
                    this.response = true;
                    this.resetingPassword = false;
                }, error => {
                    this.response = false;
                    this.resetingPassword = false;
                })
        }
    }
}